module.exports = __webpack_public_path__ + "static/media/profile.7c4aed56.png";